import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { UploadComponent } from '@material-library';

@Component({
  selector: 'app-upload-files',
  templateUrl: './upload-files.component.html',
  styleUrls: ['./upload-files.component.scss']
})
export class UploadFilesComponent{
  @Input() onUpload: (files: File[]) => void;
  @Input() onDrop: () => void;
  @Input() isPublicUpload?: boolean = false;


  @ViewChild('uploadInput') uploadInput!: ElementRef<HTMLInputElement>;

  constructor(){}

  onFileSelected(event: any) {
    const files: File[] = event.target.files;
    this.onUpload(files);
  }

  handleFileUpload(files: File[]) {
    this.onUpload(files)
  }

  onUploadButtonClick = () => {
    if (this.uploadInput) {
      this.uploadInput.nativeElement.value = '';
      this.uploadInput.nativeElement.click();
    }
  }
}
